"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.Wrapper = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _rebass = require("rebass");

var Wrapper = (0, _styled.default)(_rebass.Box)(function (_ref) {
  var hasLabel = _ref.hasLabel,
      _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      space = _ref$theme.space,
      mediaQueries = _ref$theme.mediaQueries,
      expandUp = _ref.expandUp;
  return {
    '.chq-atc': _defineProperty({
      position: 'relative'
    }, mediaQueries.small, {
      display: 'inline-block'
    }),
    '.chq-atc--button': _defineProperty({
      border: 'none',
      padding: '0',
      margin: '0',
      width: hasLabel ? '100%' : 'auto',
      background: 'transparent'
    }, mediaQueries.small, {
      width: 'auto'
    }),
    '.chq-atc--dropdown': {
      position: 'absolute',
      zIndex: '1',
      width: '100%',
      minWidth: '17rem',
      boxShadow: 'rgba(0,0,0,0.4) 0 1.1rem 2.2rem',
      border: '1px solid #a8a8a8',
      backgroundColor: colors.white,
      textAlign: 'left',
      top: expandUp ? '0' : 'initial',
      transform: expandUp ? 'translateY(-100%)' : 'translateY(0)',
      // 4th item is outlook web app which was not an option on the original add to calendar
      // also it is broken and until the plugin is updated, we will be hiding it
      // 5th item is Yahoo, which is not widely used in the business so it's hidden as well
      'a:nth-of-type(4), a:nth-of-type(5)': {
        display: 'none'
      },
      a: {
        color: colors.black,
        textDecoration: 'none',
        padding: "".concat(space.medium, " ").concat(space.base),
        display: 'block',
        '&:hover': {
          backgroundColor: colors.greymid,
          color: colors.black,
          transition: 'background-color 0.3s ease-out'
        }
      }
    }
  };
});
exports.Wrapper = Wrapper;
var _default = Wrapper;
exports.default = _default;